<template>
  <ImageWrapper
    imagePath="assets/images/KeyVisual_Account"
    imageName="KeyVisual_Account"
    :breakpoints="[404, 404, 478, 478, 1000]"
    :renderAsRow="false"
  ></ImageWrapper>
</template>

<script setup lang="ts">
import ImageWrapper from '@/components/rahmen/ImageWrapper.vue'
</script>
